import React from 'react';
import Meta from '../components/Meta';
import VirtualTemples from './VirtualTemples';

const KedarnathTemple = () => {
  // Schema markup for structured data
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "LandmarksOrHistoricalBuildings",
    "name": "Kedarnath Temple",
    "alternateName": "Kedarnath Jyotirlinga",
    "description": "Kedarnath Temple is one of the twelve Jyotirlingas, the holiest Hindu shrines of Shiva. Located in the Himalayas at an altitude of 3,583 meters in Uttarakhand, it is one of the most difficult temples to reach and part of the Char Dham pilgrimage.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Kedarnath",
      "addressLocality": "Rudraprayag",
      "addressRegion": "Uttarakhand",
      "addressCountry": "India"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "30.7333",
      "longitude": "79.0333"
    },
    "url": "https://vedamerchandise.com/kedarnath-temple",
    "image": "https://vedamerchandise.com/images/avatars/kedarnath_temple.glb"
  };

  return (
    <>
      <Meta 
        title="Kedarnath Temple - 3D Virtual Tour | VEDA Virtual Temples"
        description="Experience the divine architecture of Kedarnath Temple in Uttarakhand through our immersive 3D virtual tour. Explore the spiritual significance and intricate design of this sacred Hindu temple."
        keywords="kedarnath temple, shiva temple, jyotirlinga, 3d virtual tour, char dham, hindu temple, virtual pilgrimage, uttarakhand temple"
        author="VEDA Merchandise"
        ogTitle="Kedarnath Temple - 3D Virtual Tour"
        ogDescription="Experience the divine architecture of Kedarnath Temple in Uttarakhand through our immersive 3D virtual tour. Explore the spiritual significance and intricate design of this sacred Hindu temple."
        ogImage="https://vedamerchandise.com/images/avatars/kedarnath_temple.glb"
        ogUrl="https://vedamerchandise.com/kedarnath-temple"
        ogType="website"
        twitterCard="summary_large_image"
        twitterTitle="Kedarnath Temple - 3D Virtual Tour"
        twitterDescription="Experience the divine architecture of Kedarnath Temple in Uttarakhand through our immersive 3D virtual tour."
        twitterImage="https://vedamerchandise.com/images/avatars/kedarnath_temple.glb"
        robots="index, follow"
        canonicalUrl="https://vedamerchandise.com/kedarnath-temple"
        schemaMarkup={schemaMarkup}
      />
      <VirtualTemples defaultTempleId={4} />
    </>
  );
};

export default KedarnathTemple;